export function setFontSize(fontSize) {
    if (!fontSize) fontSize = 16;

    localStorage.setItem('fontSize', fontSize);
    document.documentElement.style.fontSize = fontSize + 'px';

    const accessibilityBoxSizes = document.querySelectorAll('.accessibility-box-sizes');
    accessibilityBoxSizes.forEach((box) => box.classList.remove('active'));
    const activeBox = document.querySelectorAll(`.accessibility-box-sizes[data-value="${fontSize}"]`);

    if (activeBox) activeBox.forEach((box) => box.classList.add('active'));
}

export function setContrast(contrast) {
    if (contrast) {
        document.body.classList.add('dark');
        localStorage.setItem('contrast', true);
        const activeContrast = document.querySelectorAll('.accesibilty-constrast-active');
        const disabledContrast = document.querySelectorAll('.accesibilty-constrast-disabled');
        if (activeContrast) activeContrast.forEach((contrast) => contrast.classList.add('active'));
        if (disabledContrast) disabledContrast.forEach((contrast) => contrast.classList.remove('active'));
    } else {
        document.body.classList.remove('dark');
        localStorage.removeItem('contrast');
        const disabledContrast = document.querySelectorAll('.accesibilty-constrast-disabled');
        const activeContrast = document.querySelectorAll('.accesibilty-constrast-active');
        if (disabledContrast) disabledContrast.forEach((contrast) => contrast.classList.add('active'));
        if (activeContrast) activeContrast.forEach((contrast) => contrast.classList.remove('active'));
    }
}

export function toggleAcessibilityBox() {
    const accessibilityBox = document.querySelectorAll('.accessibility-box');

    if (accessibilityBox) {
        accessibilityBox.forEach(function (el) {
            el.style.display = el.style.display === 'none' ? 'block' : 'none';

            setTimeout(function () {
                if (el.style.display === 'block') {
                    document.body.addEventListener('click', function hideBox() {
                        el.style.display = 'none';
                        document.body.removeEventListener('click', hideBox);
                    });
                }
            });
        });
    }
}

function loadAccessibility() {
    const contrast = localStorage.getItem('contrast');
    setContrast(contrast);

    const fontSize = localStorage.getItem('fontSize');
    setFontSize(fontSize);

    document.onkeydown = (e) => {
        if (e.ctrlKey) {
            const fontSizes = [12, 14, 16, 18];
            const currentFontSize = localStorage.getItem('fontSize') * 1;

            switch (e.key) {
                case ',':
                    e.preventDefault();
                    setContrast(true);
                    break;
                case '.':
                    e.preventDefault();
                    setContrast(false);
                    break;
                case '+':
                case '=':
                    e.preventDefault();
                    setFontSize(currentFontSize <= 16 ? currentFontSize + 2 : 18);
                    break;
                case '-':
                    e.preventDefault();
                    setFontSize(currentFontSize >= 14 ? currentFontSize - 2 : 12);
                    break;
                case '0':
                    e.preventDefault();
                    setFontSize(16);
                    break;
            }
        }
    };
}

loadAccessibility();
